const en = {
  GREETINGS: {
    SIGNUP: "Sign Up",
    LOGIN: "Login",
  },

  FORM_FIELDS: {
    NAME: "Name",
    EMAIL: "E-mail",
    PASSWORD: "Password",
    RETYPE_PASSWORD: "Retype Password",
    SIGNUP: "Sign Up",
    LOGIN: "Login",
    SIGNUP_ALT_TEXT: "Existing user?",
    LOGIN_ALT_TEXT: "New user?",
  },

  ERRORS: {
    EMPTY_EMAIL: "Email is required",
    INVALID_EMAIL: "Invalid email",
    EMPTY_PASSWORD: "Password is required",
    PASSWORD_MISMATCH: "Passwords do not match",
    AUTH: "Incorrect email/password",
  },
};

export default en;
